import { mapFolderList } from './parsers/folders';
import { toError } from './parsers/error';
export const initFolders = (settings, http) => {
  function list(folderId, options) {
    options = options || {};
    options.paging = options.paging || {};
    const requestOptions = {
      'max-results': options.paging.size || settings.foldersLimit,
      'start-index': options.paging.cursor || 1
    };
    if (folderId) {
      requestOptions.album_id = folderId;
    }
    return http.get(`${settings.apiUrl}${settings.apiPath}/albums`, requestOptions, {
      withCredentials: true
    }).then(mapFolderList).catch(toError);
  }
  return {
    list
  };
};